import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import config from '../../../../utils/confg.json'
const url = config.BackendUrl;
//| 'pending' | 'succeeded' | 'failed',
const initialState = {
    response: {},
    loading: 'idle',
    httpCode: 0,
    errorMsg: "",
    errorData: {},
  };
  

  export const getAllMandatoryItemsSetting = createAsyncThunk(
    "getAllMandatoryItemsSetting/getAllMandatoryItemsSetting",

    async (dispatch, { rejectWithValue }) => {
      try {

        const shopId = dispatch.shopId
        const serviceType = dispatch.serviceType ;

    
        const { data } = await axios.get(url + "/Apps/API/CMS/Settings/MandatoryItems/getAll?ShopId="+shopId+"&DeviceId=0&QRKey=0&ServiceType="+serviceType ,
          {
            withCredentials: true
          })
        return data;
      } catch (err) {

  
        if (err.response) {
          return rejectWithValue({ error: err.message, status: err.response.status, data: err.response.data });
  
  
        }
  
  
      }
    }
  );




 



  export const GetAllMandatoryItemsSettingSlices = createSlice({

    name: "GetAllMandatoryItemsSetting",
    initialState,
  
    reducers: {
      reset: () => initialState
    },
    extraReducers: {
      [getAllMandatoryItemsSetting.pending]: (state) => {
        state.loading = 'pending';
      },
      [getAllMandatoryItemsSetting.fulfilled]: (state, action) => {
  
        state.loading = 'succeeded';
        state.httpCode = 200;
        state.response = action.payload;
      },
      [getAllMandatoryItemsSetting.rejected]: (state, action) => {
  
        try {
          state.loading = 'failed';
          state.httpCode = action.payload.status;
          state.errorMsg = action.payload.error;
          state.response = {};
          if (action.payload.status === 409) {
            state.errorData = action.payload.data
          } else {
  
            state.response = {}
  
          }
        } catch {
  
          state.httpCode = 503;
          state.errorMsg = "service unavailable";
        }
      }







  
    }
  
  })
  
  export const { reset  } = GetAllMandatoryItemsSettingSlices.actions
  
  export default GetAllMandatoryItemsSettingSlices.reducer;